module.exports = __webpack_public_path__ + "img/744.b4bb0771.jpg";